import "./styles/app.css";
import "./styles/subscriptions.css";

import { FrontendApplication } from "./application/FrontendApplication"

const root = document.getElementById("app")

if (!root) {
  throw new Error("Root element #app not found")
}

const app = new FrontendApplication(root)

app.start()